import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { PlanModel } from '../../shared/models/plan.model';
import { CommonHttpService } from '../../shared/services/http.service';
import { Response } from '@angular/http';
import { Subscription } from 'rxjs/Subscription';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'cart-recurrent',
    templateUrl: './cart.recurrent.component.html',
    styleUrls: []
})
export class CartRecurrentComponent implements OnInit, OnDestroy {
    @Input('recurrentAs') recurrentAs: PlanModel;
    @Output('updated') updated: EventEmitter<null> = new EventEmitter<null>();
    public recurrencyModels: Array<PlanModel> = [];
    public loading = false;

    getRecurrencyModels: Subscription;

    constructor(
        protected http: CommonHttpService
    ) {}

    ngOnInit() {
        this.getRecurrencyModels = this.http
            .get('/checkout/cart/recurrency-models')
            .subscribe((response: Response) => {
                this.recurrencyModels = response.json().data;
            });
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    public remove() {
        this.loading = true;
        this.http
            .post('/checkout/cart/properties', {
                recurrent_as: null
            })
            .subscribe((response: Response) => {
                this.loading = false;
                this.updated.emit();
            }, () => {
                this.loading = false;
            });
    }
    public change(recurrencyModel: PlanModel) {
        this.loading = true;
        this.http
            .post('/checkout/cart/properties', {
                recurrent_as: recurrencyModel.id
            })
            .subscribe((response: Response) => {
                this.loading = false;
                this.updated.emit();
            }, () => {
                this.loading = false;
            });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/cart/recurrent/cart.recurrent.component.ts